import { TOGGLE_UPDATE_LG_POST } from '../actions/toggleLRPostUpdate';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    id: 0,
    updateStatus: false
};
var initialState = {};
export function toggleLongReadPostUpdate(state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case TOGGLE_UPDATE_LG_POST:
            // return { ...state, id: action.payload.id, updateStatus: action.payload.updateStatus }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { id: (_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.id, updateStatus: (_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.updateStatus }, initialData);
        default:
            return state;
    }
}
;
export function getToggleLongReadPostUpdate(state, lgId) {
    return state.toggleLongReadPostUpdate[lgId] || initialData;
}
//# sourceMappingURL=toggleLongReadPostUpdate.js.mapimport { TOGGLE_UPDATE_LG_POST } from '../actions/toggleLRPostUpdate';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    id: 0,
    updateStatus: false
};
var initialState = {};
export function toggleLongReadPostUpdate(state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case TOGGLE_UPDATE_LG_POST:
            // return { ...state, id: action.payload.id, updateStatus: action.payload.updateStatus }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { id: (_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.id, updateStatus: (_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.updateStatus }, initialData);
        default:
            return state;
    }
}
;
export function getToggleLongReadPostUpdate(state, lgId) {
    return state.toggleLongReadPostUpdate[lgId] || initialData;
}
//# sourceMappingURL=toggleLongReadPostUpdate.js.map